import { Flex, Text, Kbd } from "@radix-ui/themes";

interface ZoomPanInstructionsProps {
  className?: string;
}

export function ZoomPanInstructions({ className }: ZoomPanInstructionsProps) {
  return (
    <Flex className={`bg-white p-2 ${className || ""}`}>
      <Flex align="center" gap="4">
        <Flex align="center" gap="2">
          <Text size="1" className="text-gray-700">
            Zoom
          </Text>
          <Kbd>Control + Mouse Wheel</Kbd>
        </Flex>
        <Text size="1" className="text-gray-500">
          •
        </Text>
        <Flex align="center" gap="2">
          <Text size="1" className="text-gray-700">
            Pan
          </Text>
          <Kbd>Control + Mouse Drag</Kbd>
        </Flex>
      </Flex>
    </Flex>
  );
}
